import {
  SET_CURRENT_GROUP,
  SET_PUBLIC_GROUP,
} from '../actions/group-actions.ts';

const initialState = {
  group: {},
};

export default (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_PUBLIC_GROUP:
    case SET_CURRENT_GROUP:
      if (typeof action.group.$clone !== 'function') {
        // Make sure group is a resource and contains $clone method
        throw Error('GroupReducer: group must be an instance of GroupResource');
      }

      action.group = Object.assign(action.group, { accounts: [] });
      return action.group;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./main/reducers/group-reducer.js